"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = require("../../../utils/constants");
var _WindowAPI = _interopRequireDefault(require("../../WindowAPI"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const PERU_FLOWS = [(_ref, config) => {
  let {
    brand
  } = _ref;
  if (!WindowAPIPe.isValidBrand(brand, config)) {
    console.log('Brand not valid', brand);
    return {
      name: 'BrandFlow',
      params: {
        recommendationCategories: [],
        enable: [],
        hideQuestionsById: []
      }
    };
  }
  console.log('Brand valid', brand);
  return {
    name: 'BrandFlow',
    params: {
      recommendationCategories: [{
        category: 'handset',
        filters: {
          brand: [brand]
        }
      }],
      enable: [],
      hideQuestionsById: [_constants.QUESTION_ID.BRANDS]
    }
  };
}];
class WindowAPIPe extends _WindowAPI.default {
  constructor(props) {
    if (_WindowAPI.default.instance) return _WindowAPI.default.instance;
    super(props);
    this.flows = PERU_FLOWS;
    this.exposeFlows();
  }
}
WindowAPIPe.isValidBrand = (brandName, config) => {
  var _config$questions, _config$questions$fin, _config$questions$fin2, _config$questions$fin3;
  return config === null || config === void 0 ? void 0 : (_config$questions = config.questions) === null || _config$questions === void 0 ? void 0 : (_config$questions$fin = _config$questions.find(question => question.id === _constants.QUESTION_ID.BRANDS)) === null || _config$questions$fin === void 0 ? void 0 : (_config$questions$fin2 = _config$questions$fin.choices.map(choice => {
    var _choice$characteristi;
    return (_choice$characteristi = choice.characteristics[0].filter) === null || _choice$characteristi === void 0 ? void 0 : _choice$characteristi[0];
  })) === null || _config$questions$fin2 === void 0 ? void 0 : (_config$questions$fin3 = _config$questions$fin2.filter(el => el)) === null || _config$questions$fin3 === void 0 ? void 0 : _config$questions$fin3.includes(brandName);
};
var _default = WindowAPIPe; // Example usage
// guidedSelling.handsetFlowChile.BrandFlow({"brand":"Apple"});
exports.default = _default;